module.exports = __webpack_public_path__ + "img/183-hong-kong.6befc07b.svg";